// extracted by mini-css-extract-plugin
export default {"text":"footer_text__57Kjg"};